var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneratingCaptionIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 84,
    viewBox: "0 0 130 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4513 34.0109H13.5161C13.9002 38.8334 17.9464 38.9078 17.9464 38.9078C17.9464 38.9078 13.4844 38.9849 13.4844 44.5575C13.4844 38.9849 9.02234 38.9078 9.02234 38.9078C9.02234 38.9078 13.0672 38.8334 13.4513 34.0109Z",
    fill: "#E1E4E5",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05629 15.3515C2.81601 15.3515 0.999903 17.1676 0.999903 19.4079C0.999903 21.6482 2.81601 23.4643 5.05629 23.4643C7.29657 23.4643 9.11267 21.6482 9.11267 19.4079C9.11267 17.1676 7.29657 15.3515 5.05629 15.3515Z",
    fill: "#79F3BD",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2302 82.4422C96.5057 82.4422 95.1077 81.0442 95.1077 79.3197C95.1077 77.5952 96.5057 76.1973 98.2302 76.1973C99.9547 76.1973 101.353 77.5952 101.353 79.3197C101.353 81.0442 99.9547 82.4422 98.2302 82.4422Z",
    fill: "#E1E4E5",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9771 5.84782C30.4915 7.76773 29.3522 9.74116 27.4323 10.2556C25.5124 10.77 23.5389 9.63068 23.0245 7.71077C22.5101 5.79086 23.6494 3.81743 25.5693 3.30299C27.4892 2.78856 29.4627 3.92792 29.9771 5.84782Z",
    fill: "#E1E4E5",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.629 81.695C122.215 81.695 120.257 79.7379 120.257 77.3236C120.257 74.9093 122.215 72.9521 124.629 72.9521C127.043 72.9521 129 74.9093 129 77.3236C129 79.7379 127.043 81.695 124.629 81.695Z",
    fill: "#E1E4E5",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.284 46.9913H113.384C113.975 54.4157 120.205 54.5302 120.205 54.5302C120.205 54.5302 113.335 54.649 113.335 63.2281C113.335 54.649 106.466 54.5302 106.466 54.5302C106.466 54.5302 112.693 54.4157 113.284 46.9913Z",
    fill: "#79F3BD",
    stroke: "#7B838D",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6699 13.0776L37.3163 12.724L37.6699 13.0776C52.3613 -1.61456 76.1909 -1.61465 90.8865 13.0776C105.582 27.7735 105.582 51.6002 90.8865 66.2964C76.191 80.9925 52.3652 80.9925 37.6699 66.2964C22.9743 51.6002 22.9743 27.7735 37.6699 13.0776Z",
    fill: "white",
    stroke: "#7B838D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5468_34148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 1,
    width: 77,
    height: 77
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8462 13.2537L37.8462 13.2537C52.4399 -1.3408 76.1114 -1.3409 90.7093 13.2538C105.307 27.8521 105.307 51.5205 90.7093 66.119C76.1114 80.7174 52.4439 80.7174 37.8462 66.119C23.2482 51.5205 23.2482 27.852 37.8462 13.2537Z",
    fill: "white",
    stroke: "#7B838D",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5468_34148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3445 88.3562V59.8095L82.8943 51.742C83.8873 52.7349 83.7218 73.2554 83.5149 83.3916L72.3445 88.3562Z",
    fill: "#C5FCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3513 82.3927V58.2898L45.4437 51.4781C44.6053 52.3165 44.7451 69.6426 44.9197 78.2009L54.3513 82.3927Z",
    fill: "#C5FCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3627 24.7568L64.1744 29.9966L70.9861 24.7568L64.1744 11.6574L57.3627 24.7568Z",
    fill: "#66DEA9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4789 78.8476V54.1511C44.4789 51.8245 45.0233 49.5276 46.0777 47.4535L64.2797 11.4308L82.4815 47.4535C83.5343 49.529 84.0822 51.8238 84.0805 54.1511V78.8476",
    stroke: "#7B838D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6535 81.8688C66.6891 84.3839 57.3623 82.9168 53.6945 81.8688L54.2184 57.7659L64.174 49.9062L74.6535 57.7659V81.8688Z",
    fill: "#66DEA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5619 50.9003L74.3087 57.9445L64.1293 49.9077L54.2504 57.9445L44.86 50.9003M71.0387 24.7456L64.1293 30.0972L57.6597 25.0871M54.0862 57.3904V82.0074M74.4222 57.3904V82.555",
    stroke: "#7B838D",
    strokeWidth: 1.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.8729,
    cy: 39.6891,
    rx: 37.7244,
    ry: 38.13,
    stroke: "#7B838D",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratingCaptionIllustration);
export default __webpack_public_path__ + "static/media/generatingCaptionIllustration.23bd66d28ab9a03285a434e72575f3d9.svg";
export { ForwardRef as ReactComponent };